<!-- 文章列表 -->
<template>
    <div
        v-if="componentsData.type == 7"
        class="bg-div"
        :style="
            componentsData.content.version
                ? {
                      ...(componentsData.content.bg_color && {
                          backgroundColor: componentsData.content.bg_color,
                      }),
                      ...(componentsData.content.bg_img.picview &&
                          componentsData.content.bg_value && {
                              backgroundImage: `url(${componentsData.content.bg_img.picview})`,
                          }),
                      padding: `${componentsData.content.paddingData.top}px ${componentsData.content.paddingData.left}px`,
                      margin: `${componentsData.content.marginData.top}px ${componentsData.content.marginData.left}px`,
                      borderRadius: `${componentsData.content.radiusData.top}px ${componentsData.content.radiusData.top}px ${componentsData.content.radiusData.bottom}px ${componentsData.content.radiusData.bottom}px`,
                  }
                : `padding: ${componentsData.content.marginData.top}px ${componentsData.content.marginData.left}px;background: ${componentsData.content.bg_color};border-radius: ${componentsData.content.marginData.topRadius}px ${componentsData.content.marginData.topRadius}px ${componentsData.content.marginData.bottomRadius}px ${componentsData.content.marginData.bottomRadius}px`
        "
    >
        <div class="container">
            <div class="card">
                <div class="card-left">
                    <div
                        :style="`color: ${componentsData.content.title_color};font-size: ${componentsData.content.title_size}px;`"
                    >
                        文章标题
                    </div>
                    <div
                        v-if="componentsData.content.time_value"
                        :style="`color: ${componentsData.content.time_color}`"
                    >
                        2026-04-01
                    </div>
                </div>
                <div class="card-right"></div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        componentsData: {
            type: Object,
            default: {},
        },
    },
    data() {
        return {};
    },
    computed: {
        decLeft() {
            return `linear-gradient(to left, ${this.componentsData.content.dec_color}, transparent)`;
        },
        decRight() {
            return `linear-gradient(to right, ${this.componentsData.content.dec_color}, transparent)`;
        },
    },
    mounted() {},
    methods: {},
};
</script>

<style scoped>
.header {
    padding-bottom: 6px;
    border-bottom: 1px solid #ccc;
}
.card {
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.card-left {
    height: 70px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    font-family: Microsoft YaHei;
    font-weight: 400;
    font-size: 13px;
}
.card-right {
    width: 122px;
    height: 80px;
    background: #c9d0e7;
    border-radius: 5px;
}
.bg-div {
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
}
</style>